"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const noop_1 = __importDefault(require("lodash/noop"));
const InvestmentTransactionTypeField_1 = __importDefault(require("components/InvestmentTransactionTypeField"));
const styles_1 = require("../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const ActionField = ({ attributes, SHOW_ALL, txn, editClass, hoverClass, }) => {
    const { classes } = useStyles();
    return (<styles_1.RegListItem {...attributes} tabIndex={null} onClick={null} className={(0, classnames_1.default)(classes.regItem, 'protectWidth', editClass, hoverClass)}>
      {SHOW_ALL && (<InvestmentTransactionTypeField_1.default id="type" sx={{ minWidth: null }} forcePopupIcon={false} readOnly textFieldProps={{
                variant: 'standard',
                label: null,
                InputProps: {
                    disableUnderline: true,
                },
            }} value={txn.type === 'INVESTMENT' ? txn.investmentTxnType : 'VIRTUAL_CASH_FLOW'} onChange={noop_1.default}/>)}
    </styles_1.RegListItem>);
};
exports.default = ActionField;
